import { createBrowserRouter, Navigate } from 'react-router-dom';
import { wrapCreateBrowserRouterV7 } from '@sentry/react';

import PlanSelect from './routes/PlanSelect';
import Page from './pages';
import PlanSelectPageLayout from '../components/PlanSelectPageLayout';
import { getBasename } from '../helpers/functions/navigation';
import ErrorElement from '../../shared/components/ErrorElement';
import OverflowLoader from '../../shared/components/OverflowLoader';
import { authenticationLoader } from './loaders/authentication';

const routesConfig = [
  {
    element: <PlanSelectPageLayout />,
    errorElement: <ErrorElement />,
    HydrateFallback: () => <OverflowLoader />,
    children: [
      {
        loader: authenticationLoader,
        children: [
          {
            path: Page.planSelect,
            element: <PlanSelect />,
          },
        ],
      },
    ],
  },
  { path: '*', element: <Navigate to={Page.planSelect} replace /> },
];

const sentryCreateBrowserRouter =
  wrapCreateBrowserRouterV7(createBrowserRouter);

const configuredRouter = sentryCreateBrowserRouter(routesConfig, {
  basename: getBasename() || '/',
});

export default configuredRouter;
